<div class="metin-notu-dialog">
  <!-- Toolbar - Point Selection -->
  <div class="catia-toolbar">
    <div class="toolbar-grup">
      <div class="ayar-satir">
        <button class="catia-btn" [class.active]="baslangicNokta" (click)="baslangicNoktasiSec()"
                style="flex: 1; background: linear-gradient(135deg, rgba(0, 255, 255, 0.15), rgba(0, 255, 255, 0.25)); border-color: rgba(0, 255, 255, 0.4); color: #00FFFF;">
          <i class="icon map marker alternate"></i>
          {{baslangicNokta ? 'Başlangıç ✓' : 'Başlangıç Noktası Seç'}}
        </button>
        <button class="catia-btn" [class.active]="bitisNokta" (click)="bitisNoktasiSec()"
                style="flex: 1; background: linear-gradient(135deg, rgba(255, 215, 0, 0.15), rgba(255, 215, 0, 0.25)); border-color: rgba(255, 215, 0, 0.4); color: #FFD700;">
          <i class="icon map marker alternate"></i>
          {{bitisNokta ? 'Bitiş ✓' : 'Bitiş Noktası Seç'}}
        </button>
      </div>
    </div>
  </div>

  <!-- Control Panel -->
  <div class="kontrol-paneli">

    <!-- Ölçü Ayarları -->
    <div class="ayar-sekme">
      <div class="sekme-baslik" (click)="olcuAyarlariAcik = !olcuAyarlariAcik">
        <i class="icon ruler combined"></i>
        <span>Ölçü Ayarları</span>
        <div class="chevron" [class.right]="!olcuAyarlariAcik" [class.down]="olcuAyarlariAcik"></div>
      </div>

      @if (olcuAyarlariAcik) {
      <div class="sekme-icerik">
        <!-- Birim -->
        <div class="ayar-satir">
          <label>Birim:</label>
          <select [(ngModel)]="birim" (ngModelChange)="onizlemeGuncelle()" class="catia-select">
            <option value="mm">mm</option>
            <option value="cm">cm</option>
            <option value="m">m</option>
            <option value="in">in</option>
          </select>
        </div>

        <!-- Offset -->
        <div class="ayar-satir">
          <label>Offset:</label>
          <div class="slider-kontrol">
            <input type="range" [(ngModel)]="offset" (ngModelChange)="onizlemeGuncelle()"
                   min="0.1" max="2" step="0.1" />
            <span class="deger-gosterge">{{offset.toFixed(1)}}</span>
          </div>
        </div>

        <!-- Ok Boyutu -->
        <div class="ayar-satir">
          <label>Ok Boyutu:</label>
          <div class="slider-kontrol">
            <input type="range" [(ngModel)]="okBoyutu" (ngModelChange)="onizlemeGuncelle()"
                   min="0.1" max="0.5" step="0.05" />
            <span class="deger-gosterge">{{okBoyutu.toFixed(2)}}</span>
          </div>
        </div>
      </div>
      }
    </div>

    <!-- Görünüm Ayarları -->
    <div class="ayar-sekme">
      <div class="sekme-baslik" (click)="gorunumAyarlariAcik = !gorunumAyarlariAcik">
        <i class="icon eye"></i>
        <span>Görünüm Ayarları</span>
        <div class="chevron" [class.right]="!gorunumAyarlariAcik" [class.down]="gorunumAyarlariAcik"></div>
      </div>

      @if (gorunumAyarlariAcik) {
      <div class="sekme-icerik">
        <!-- Renk -->
        <div class="ayar-satir">
          <label>Renk:</label>
          <div class="renk-kontrol">
            <div class="renk-palette">
              @for (r of renkler; track r) {
              <div class="renk-kutu" [style.background-color]="r"
                   [class.secili]="renk === r"
                   (click)="renk = r; onizlemeGuncelle()"></div>
              }
            </div>
            <input type="color" [(ngModel)]="renk" (ngModelChange)="onizlemeGuncelle()" class="renk-input" />
          </div>
        </div>

        <!-- Font Boyutu -->
        <div class="ayar-satir">
          <label>Yazı Boyutu:</label>
          <div class="slider-kontrol">
            <input type="range" [(ngModel)]="boyut" (ngModelChange)="onizlemeGuncelle()"
                   min="8" max="24" step="1" />
            <span class="deger-gosterge">{{boyut}}px</span>
          </div>
        </div>

        <!-- Sabit Boyut -->
        <div class="ayar-satir">
          <label>Sabit Boyut:</label>
          <div class="checkbox-kontrol">
            <input type="checkbox" [(ngModel)]="sabitBoyut" (ngModelChange)="sabitBoyutDegistir()" id="sabitBoyutBoyut" class="catia-checkbox">
            <label for="sabitBoyutBoyut" class="checkbox-label">Aktif</label>
          </div>
        </div>
      </div>
      }
    </div>

  </div>

  <!-- Action Bar -->
  <div class="aksiyon-bar">
    <button class="catia-btn ekle-btn" (click)="ekle()" [disabled]="!baslangicNokta || !bitisNokta">
      <i class="icon plus"></i>
      Ekle
    </button>
    <button class="catia-btn kapat-btn" (click)="kapat()">
      <i class="icon times"></i>
      Kapat
    </button>
  </div>
</div>
